import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { IEditOptions } from '../site-edit.component';

@Component({
    selector:'app-settings',
    templateUrl: './microsite-settings.edit.component.html',
})
export class MicrositeSettingsEditComponent implements OnInit {
    public HModel: SMenuModel = new SMenuModel();
    @Input() EditOption:IEditOptions;
    constructor(private cdRef: ChangeDetectorRef,) { }

    ngOnInit() {
        console.log(this.EditOption)
        this.HModel.EditBackground = true;
    }

    PopulateMenu2(menu: any) {
        this.HModel.IsPageSettingActive = false;       
        this.HModel.IsSOEActive = false;   
        this.HModel.IsParagraphSettingActive = false;
        this.HModel.IsEffectsActive = false;
        this.HModel.IsBackgroundActive = false;
        this.HModel.ShowPageSettings = false;
        this.HModel.ShowSectionList = false;
        this.HModel.ShowBackgroundSettings = false;
        switch (menu) {
            case "Page":
                this.HModel.IsPageSettingActive = true;
                this.HModel.ShowPageSettings = true;
                this.HModel.View = "P";
                break;
            case "Background":
                this.HModel.IsBackgroundActive = true;
                this.HModel.ShowBackgroundSettings = true;
                this.HModel.View = "B";
                break;
             case "SEO":
                 this.HModel.IsSOEActive = true;
                 this.HModel.ShowSEO = true;
                 this.HModel.View = "S";
                 break;    
        }
        this.cdRef.detectChanges();
    }
}

export class SMenuModel {
    ShowSectionList: boolean = false;
    EditBackground: boolean = false;
    ShowBackgroundSettings: boolean = false;
    ShowSEO: boolean = false;
    ShowPageSettings: boolean = true;
    IsPageSettingActive: boolean = true;
    IsParagraphSettingActive: boolean = false;
    IsEffectsActive: boolean = false;
    IsBackgroundActive: boolean = false;
    IsSOEActive:boolean=false;
    IsSectionEdit: boolean = true;
    View: string = "P";
}
